export function loadGoogleAnalytics() {
  // Create and load the Google Analytics script
  const gtagScript = document.createElement("script");
  gtagScript.async = true;
  gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=G-761P1G51EY";
  document.head.appendChild(gtagScript);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  
  window.gtag = gtag;
  
  gtag("js", new Date());
  gtag("config", "G-761P1G51EY");
}
